import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { CartButton } from '@zooplus/ui-components';
import { useTracking } from '../../../hooks/useTracking.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useConfig } from '../../../providers/ConfigProvider.js';
import CoreProviders from '../../../providers/CoreProviders.js';
import { PaymentContextProvider, usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import { authorizePayment } from '../../../services/braintreeService.js';
import styles from './BraintreeAuthorizationButton.module.scss.js';

const BraintreeAuthorizationButtonWrapped = () => {
    const { appConfig, checkoutState } = usePaymentContext();
    const { braintreeButton, currency, customerId, grandTotal: amount, isPlaceOrderButtonEnabled, isPaymentLoading: loading, customerType, sid, } = checkoutState || {};
    const { pspToken, braintreeNonceToken, additional3DSInfo, subscriptionFirstInterval, braintreeBin, cardUsageType, onSubmit, subscriptionFirst, } = braintreeButton || {};
    const { shop, locale, environment, realm } = appConfig || {};
    const { domain, siteId } = shop || {};
    const price = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount || 0);
    return (jsx(CoreProviders, { env: environment, shopBundle: realm, locale: locale, domain: domain ?? '', errorContainerId: '', featureName: "braintree-authorization", children: jsx(InnerBraintreeAuthorizationButton, { siteId: siteId, sid: sid, token: pspToken, nonce: braintreeNonceToken, bin: braintreeBin, amount: amount, currency: currency, customerType: customerType, additional3dsInfo: additional3DSInfo, cardType: cardUsageType, isSubscriptionFirst: subscriptionFirst, subscriptionFirstInterval: subscriptionFirstInterval, customerId: customerId?.toString(), price: price, disabled: !isPlaceOrderButtonEnabled, loading: loading ?? true, onSubmit: onSubmit }) }));
};
const InnerBraintreeAuthorizationButton = ({ token, nonce, bin, amount, onSubmit, price, siteId, sid, currency, customerType, additional3dsInfo, cardType, isSubscriptionFirst, subscriptionFirstInterval, customerId, disabled, loading, }) => {
    const { t } = useTranslation();
    /**
     * Logic to be clarified when to call the authorization!
     * Authorization should not be called again if it has already been called.
     */
    //This are the dummy values , real values will be added under the PAYM-803
    const fraudPreventionRecommendation = 'ALLOW';
    const { clientId } = useConfig().config.optimizely;
    const track = useTracking({
        sid,
        siteId,
        currency,
        customerId,
        guest: customerType === 'GUEST_CUSTOMER',
    });
    const handleAuthorize = useCallback(async () => {
        const result = await authorizePayment({
            t,
            token,
            bin,
            nonce,
            amount,
            siteId,
            cardType,
            isSubscriptionFirst,
            subscriptionFirstInterval,
            additional3dsInfo,
            customerId,
            fraudPreventionRecommendation,
            optimizelyId: clientId,
            track,
        });
        result.success && onSubmit?.(result.deviceData, result.nonce);
    }, [
        t,
        token,
        bin,
        nonce,
        amount,
        additional3dsInfo,
        cardType,
        isSubscriptionFirst,
        subscriptionFirstInterval,
    ]);
    const onClick = (e) => {
        e.preventDefault();
        handleAuthorize();
    };
    return (jsx(CartButton, { id: "makeTheOrder", name: "placeOrder", "data-zta": "placeOrderBtn", "data-testid": "placeOrderBtn", formNoValidate: true, className: `z-btn--wide ${styles.cartButton}`, onClick: onClick, disabled: disabled, isLoading: loading, children: t('checkout.button.order', { 0: price }) }));
};
const BraintreeAuthorizationButton = ({ isDataMocked }) => {
    return (jsx(PaymentContextProvider, { isDataMocked: isDataMocked, children: jsx(BraintreeAuthorizationButtonWrapped, {}) }));
};

export { BraintreeAuthorizationButton as default };
//# sourceMappingURL=BraintreeAuthorizationButton.js.map
